export default {
  "HitPaw Online Audio Converter": "HitPaw Convertisseur audio en ligne",
  "Convert audios to MP3, AAC, FLAC, WMA and more formats for free.": "Convertissez gratuitement des fichiers audio en formats MP3, AAC, FLAC, WMA et autres.",
  'HitPaw Online Image Converter': "HitPaw Convertisseur d'images en ligne",
  'Convert images to JPG, PNG, BMP, TIFF and more formats for free.': 'Convertissez gratuitement des images en formats JPG, PNG, BMP, TIFF et autres.',
  'HitPaw Online Video Converter': 'HitPaw Convertisseur de vidéo en ligne',
  'Convert videos to any formats as your requirements.': "Convertissez des vidéos dans n'importe quel format selon vos besoins.",
  'Add More Files': 'Ajouter plus de fichiers',
  'Convert to': 'Convertissez en',
  'Ready': 'Prêt',
  'Converting': 'Conversion en cours',
  'Video': 'Vidéo',
  'Audio': 'Audio',
  'Image': 'Image',
  'Retry': 'Réessayez',
  'Download All': 'Téléchargez tout',
  'Download Desktop': 'Téléchargez la version pour bureau',
  'Continue Editing': 'Continuez à éditer',
  'Convert': 'Convertir',
  'Cut': 'Couper',
  'Speed': 'Vitesse',
  'Crop & Rotate': 'Réduire et faire tourner',
  'Resize': 'Redimensionner',
  'Extract': 'Extraire',
  'Add Music': 'Ajouter de la musique',
  'Subtitles': 'Sous-titres',
  'Merge': 'Fusionner',
  'Watermark Remover': 'Suppression du filigrane',
  'Add Watermark': 'Ajouter un filigrane',
  'Please select a file to use': 'Sélectionnez un fichier  pour utiliser {{work}}',
  'Batch Processing': 'Batch Processing',
};
